<template>
  <CCard>
    <CCardHeader>
      <strong>New Bkash Banner</strong>
    </CCardHeader>
    <CCardBody>
      <CRow class="mt-3">
        <CCol sm="6">
          <CSelect label="Banner Type" :options="banner_types" :value.sync="banner_type" />
        </CCol>
        <CCol sm="6">
          <CSelect label="Platform" :options="nagorik_games" :value.sync="nagorik_game" />
        </CCol>
      </CRow>
      <CRow class="mt-3">
        <CCol sm="12">
          <CInput class="m-3" type="text" v-model="redirect_url" label="Redirect Url" />
        </CCol>
      </CRow>
      <CRow v-if="banner_url">
        <CCol sm="12" >
          <img :src="banner_url" style="width: 200px ;height:200px" />
          <br>
          <CButton color="danger" @click="removeBanner()"><CIcon name="cil-trash" /></CButton>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CInputFile
              label="Image thumbnail"
              vertical
              ref="image"
              type="image"
              id="image"
              @change="onImageChange"
          />
          <!--<input type="file" class="form-control" v-on:change="onImageChange">-->
          <label class="text-danger"
          >*Image Size should be (750 X 126) for and less than 1 MB</label
          ><br>
          <label class="text-danger"
          >*Image Size should be (768 x 305) and less than 1 MB</label
          >
        </CCol>
      </CRow>

      <CRow>
        <CCol sm="6">
          <input class="m-3" type="number" v-model="weight" />Weight
        </CCol>
        <CCol sm="6">
          <input class="m-3" type="checkbox" v-model="is_published" />Publish
        </CCol>
      </CRow>
    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmit" color="primary"
      ><CIcon name="cil-check-circle" /> Add Banner</CButton
      >
    </CCardFooter>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  name: "BkashBannerCreate",
  data() {
    return {
      weight:null,
      banner_type: null,
      nagorik_game: null,
      image: "",
      is_published: false,
      banner_types: [],
      nagorik_games:[{value:null,label:'Bkash Landing'}],
      banner_url:null,
      redirect_url:null
    };
  },
  created() {
    this.getNagorikGames();
    this.getBannerTypes();
  },
  methods: {
    getBannerTypes() {
      this.$axios
          .get(`${ADMIN_URL}/get-bkash-banner-types`)
          .then((response) => {
            Object.entries(response.data.banner_types).forEach(([key,value]) => {
              // console.log(key,value);
              this.banner_types.push({
                value: key,
                label: value,
              });
            });
            this.banner_type= this.banner_types[0].value
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    onImageChange(e) {
      console.log("event", e[0]);
      this.image = e[0];
      if (this.image === undefined) {
        return;
      }
      this.banner_url = URL.createObjectURL(this.image);
    },
    convertTitle(s){
      return s.replace (/^[-_]*(.)/, (_, c) => c.toUpperCase())       // Initial char (after -/_)
          .replace (/[-_]+(.)/g, (_, c) => ' ' + c.toUpperCase());
    },
    getNagorikGames() {
      this.$axios
          .get(`${ADMIN_URL}/nagorik-games`)
          .then((response) => {
            this.nagorik_games = [{value:null,label:'Bkash Landing'}];
            response.data.nagorik_games.forEach((item)=>{
              this.nagorik_games.push({value:item.slug,label:item.game_name})
            })
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    removeBanner() {
      this.banner_url = "";
      this.image=null;
    },
    onSubmit(e) {
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };

      let formData = new FormData();
      if(this.banner_type!=null){
        formData.append("banner_type", this.banner_type);
      }
      if(this.image != null){
        formData.append("image", this.image);
      }
      if(this.redirect_url != null){
        formData.append("redirect_url", this.redirect_url);
      }
      formData.append("is_published", this.is_published);
      formData.append("nagorik_game_slug", this.nagorik_game);
      formData.append("weight", this.weight);
      formData.append("_method", "put");


      this.$axios
          .post(`${ADMIN_URL}/bkash-banner`, formData, config)
          .then((response) => {
            console.log("Success", response);
            currentObj.success = response.data.success;
            console.log(response.data);
            this.$swal("Success", response.data.message, "success");
             window.location.href = "/bkash-promotions/banners";
          })
          .catch((error) => {
            console.log("Error  ... ", error.response);
            currentObj.output = error;
            this.$swal("Error", error.response.message, "error");
          });
    },
  },
};
</script>

<style scoped>
</style>
